import { api } from "./client";

// --- Типове ---

// Заявка за вход в тестов режим с кода за тестов режим
export interface ConfirmAccessRequest {
  code2: string; // произволна дължина (0.0.135), само цифри
}

// Отговор от confirm-access и deny-access ендпойнтите
export interface AccessResponse {
  access: boolean;
}

// --- API функции ---

/**
 * POST /access/confirm-access
 * Вход в тестов режим чрез кода за тестов режим (code2).
 * JWT токенът се подава автоматично от axios interceptor-а.
 */
export async function confirmAccess(
  data: ConfirmAccessRequest,
): Promise<AccessResponse> {
  const response = await api.post<AccessResponse>(
    "/access/confirm-access",
    data,
  );
  return response.data;
}

/**
 * POST /access/deny-access
 * Премахва достъпа на текущата активна сесия (сетва access = false).
 * JWT токенът се подава автоматично от axios interceptor-а.
 */
export async function denyAccess(): Promise<AccessResponse> {
  const response = await api.post<AccessResponse>("/access/deny-access");
  return response.data;
}
